module.exports = __webpack_public_path__ + "img/market-evaluation.b2bb7aff.png";